import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { parseHtml } from '@change-corgi/core/react/html';

import type { SessionUser } from 'src/shared/session';

import { FacebookButton } from './components/FacebookButton';
import { GoogleButton } from './components/GoogleButton';
import { useLoginModalSocialAuth } from './hooks/useLoginModalSocialAuth';

type Props = {
	googleAuthEnabled: boolean;
	onSuccess: (user: SessionUser) => void;
};

export const LoginModalSocialAuth: React.FC<Props> = ({ onSuccess, googleAuthEnabled }) => {
	const {
		data: { error },
		actions: { handleError },
	} = useLoginModalSocialAuth();

	return (
		<>
			{error && (
				<Alert variant="error" className="mb-4 px-2">
					{parseHtml(error)}
				</Alert>
			)}
			{googleAuthEnabled && (
				<div className="mb-4">
					<GoogleButton onSuccess={onSuccess} onError={handleError} />
				</div>
			)}
			<div>
				<FacebookButton onSuccess={onSuccess} onError={handleError} />
			</div>
		</>
	);
};
